import {
  Animation,
  MainHeroSlice,
} from '@adapters/prismic/types/brandedStorePage';
import { MainHeroData } from '_components/MainHero/types';
import { HeroCta } from '_components/HeroInfoCard/types';

/**
 * Maps a Prismic `main_hero` slice `primary` into `MainHeroData`. Shared by
 * the Category, Landing and Homepage slice handlers since the slice has the
 * identical field shape on all three custom types.
 */
const mapMainHeroData = (primary: MainHeroSlice['primary']): MainHeroData => {
  const ctas: HeroCta[] = [
    primary.cta_1_label && primary.cta_1_link
      ? { label: primary.cta_1_label, url: primary.cta_1_link, slot: 0 }
      : null,
    primary.cta_2_label && primary.cta_2_link
      ? { label: primary.cta_2_label, url: primary.cta_2_link, slot: 1 }
      : null,
  ].filter((cta): cta is HeroCta => cta !== null);

  const infoCard =
    primary.info_card_description &&
    primary.info_card_cta_label &&
    primary.info_card_cta_link
      ? {
          description: primary.info_card_description,
          cta: {
            label: primary.info_card_cta_label,
            url: primary.info_card_cta_link,
          },
        }
      : null;

  return {
    h1: primary.title ?? '',
    subCopy: primary.sub_copy?.trim() || null,
    image: primary.image ?? null,
    mobileImage: primary.image_mobile ?? null,
    ctas,
    infoCard,
    animation: primary.animation ?? Animation.none,
    coOpBrand: primary.co_op_brand?.trim() || null,
  };
};

export default mapMainHeroData;
